
import { Vue, Component, Prop } from 'vue-property-decorator';
import { DosyaBorcluSSKCevap, sskIsyeriOzeti, sskTescilleri } from '@/plugins/uyap-plugin/uyap/DosyaBorcluSSK';

@Component({})
export default class SskAktifDetay extends Vue {
  @Prop() data!: DosyaBorcluSSKCevap;


  get sigortaliBilgi() {
    return this.data.sorguSonucDVO?.sskBilgiDetay?.sgkIsyeriDVO?.sigortaliBilgi;
  }

  get isyeriOzeti() {
    return sskIsyeriOzeti(this.data.sorguSonucDVO);
  }

  get tesciller() {
    return sskTescilleri(this.data.sorguSonucDVO);
  }

  get sgkIsyeriDVO() {
    return this.data.sorguSonucDVO?.sskBilgiDetay?.sgkIsyeriDVO || {};
  }

  get hasData() {
    return !!this.sigortaliBilgi || !!this.isyeriOzeti || this.tesciller.length > 0;
  }

  get vergiNo() {
    return this.isyeriOzeti?.teVergiNo || '';
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.$toast.success('Kopyalandı: ' + text);
    });
  }
}
